import type { BrowserTabDefaults } from '../../models/entities/browser-tab-defaults.model';
import type { EventsMockSettings } from '../../models/entities/events-mock-settings.model';
import type { LoginSessionDefaults } from '../../models/entities/login-session-defaults.model';
import type { ApiEndpointDefinition } from '../api-endpoint.types';

export const PAGE_ENDPOINTS = {
  loginSessionDefaults: {
    id: 'session-defaults',
    method: 'GET',
    apiPath: '/api/pages/login/session-defaults',
    page: 'login',
    entity: 'session-defaults',
  } satisfies ApiEndpointDefinition<LoginSessionDefaults>,
  browserTabDefaults: {
    id: 'browser-tab-defaults',
    method: 'GET',
    apiPath: '/api/pages/events/browser-tab-defaults',
    page: 'events',
    entity: 'browser-tab-defaults',
  } satisfies ApiEndpointDefinition<BrowserTabDefaults>,
  eventsMockSettings: {
    id: 'events-mock-settings',
    method: 'GET',
    apiPath: '/api/pages/events/mock-settings',
    page: 'events',
    entity: 'events-mock-settings',
  } satisfies ApiEndpointDefinition<EventsMockSettings>,
} as const satisfies Record<string, ApiEndpointDefinition>;
